<template>
  <div class="expartiate-description" v-if="showData">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$lange == 'en' ? 'Job Order' : '工单详情'"
        name="description"
      >
        <div class="exp-des">
          <div class="top">
            <div class="msg-lists">
              <div class="msg-list flex-between">
                <!--                                <p>{{$lange == 'en' ? 'Order type' : '工单类型'}}:-->
                <!--                                    <template v-if="$lange == 'en'">-->
                <!--                                        {{["Installation service", "After-sale service"][expatriateData.workOrder.type]}}-->
                <!--                                    </template>-->
                <!--                                    <template v-else>-->
                <!--                                        {{["安装服务", "售后服务"][expatriateData.workOrder.type]}}-->
                <!--                                    </template>-->
                <!--                                </p>-->
                <p
                  class="jump-url"
                  @click="
                    gotoPage(
                      '/admin/order/des',
                      'id',
                      expatriateData.workOrder.id
                    )
                  "
                >
                  {{ $lange == "en" ? "Service Request" : "服务号" }}:
                  {{ expatriateData.workOrder.id }}
                </p>
                <p>
                  {{ $lange == "en" ? "Customer" : "客户" }}:
                  <span>{{
                    expatriateData.workOrder.customer.customerName
                  }}</span>
                </p>
                <p>FAS: {{ expatriateData.workOrder.product.fasId }}</p>
                <p>
                  {{ $lange == "en" ? "Project Manager" : "处理人" }}:
                  {{ expatriateData.workOrder.handlerName }}
                </p>
                <p>
                  {{ $lange == "en" ? "Customer Manager" : "客户经理" }}:
                  {{ expatriateData.workOrder.customer.customerManager }}
                </p>
                <p>
                  <!--占位用-->
                </p>
              </div>
              <div class="msg-list flex-between">
                <p>
                  {{ $lange == "en" ? "Product Line" : "产品线" }}:
                  {{ expatriateData.workOrder.product.productLine }}
                </p>
                <p>
                  {{ $lange == "en" ? "Speed" : "速度" }}:
                  {{ expatriateData.workOrder.product.speed }}
                </p>
                <p>
                  {{ $lange == "en" ? "Width" : "幅宽" }}:
                  {{ expatriateData.workOrder.product.breadth }}
                </p>
                <p>
                  {{ $lange == "en" ? "Staker Level" : "堆叠层数" }}:
                  {{ expatriateData.workOrder.product.stackedLayers }}
                </p>
                <p>
                  {{ $lange == "en" ? "Flutes" : "瓦楞层数" }}:
                  {{ expatriateData.workOrder.product.corrugatedLayers }}
                </p>
                <p></p>
              </div>
              <div class="msg-list flex-between">
                <p>
                  {{ $lange == "en" ? "Contact" : "申请人" }}:
                  {{ expatriateData.workOrder.userName }}
                </p>
                <p>
                  {{ $lange == "en" ? "Phone" : "联系方式" }}:
                  {{ expatriateData.workOrder.phone }}
                </p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
              </div>
            </div>
            <div class="not-padding table-box">
              <cc-table
                :config="desTableConfig"
                :data-arr="[expatriateData]"
                :load-data="false"
              ></cc-table>
            </div>
            <div class="btn">
              <el-button
                v-if="isEdit"
                type="primary"
                size="mini"
                @click="setDateFlag = true"
                >{{
                  $lange == "en" ? "Enter service time" : "录入服务时间"
                }}</el-button
              >
            </div>
          </div>
          <div class="bottom">
            <div class="title flex-between">
              <span>{{ $lange == "en" ? "Service Request" : "问题详情" }}</span>
              <el-button
                size="mini"
                @click="collapseContent = !collapseContent"
                >{{ $lange == "en" ? "Details" : "展开" }}</el-button
              >
            </div>
            <el-collapse-transition>
              <div class="content" v-show="collapseContent">
                <div class="list-title">
                  <div class="title-text">
                    {{ $lange == "en" ? "Subject" : "问题标题" }}:
                  </div>
                  <p style="color: #282828">
                    {{ expatriateData.workOrder.title }}
                  </p>
                </div>
                <div class="list-title">
                  <div class="title-text">
                    {{ $lange == "en" ? "Description" : "问题描述" }}:
                  </div>
                  <p style="color: #282828">
                    {{ expatriateData.workOrder.description }}
                  </p>
                </div>
                <div class="list-title">
                  <div class="title-text">
                    {{ $lange == "en" ? "Images" : "图片" }}:
                  </div>
                  <div class="image-lists">
                    <template
                      v-for="item in expatriateData.workOrder.accessoryInfoList"
                    >
                      <div
                        class="image-list"
                        @click="showBigImageFun(item)"
                        :style="`background: url(${item.accessoryUrl}) no-repeat center / cover`"
                      ></div>
                    </template>
                  </div>
                </div>
                <div class="list-title msg">
                  <div class="title-text">
                    {{ $lange == "en" ? "Priority" : "优先级" }}:
                    {{ tabText[expatriateData.workOrder.priority] }}
                  </div>
                  <span
                    >{{ $lange == "en" ? "Machine Association" : "机器关联" }}:
                    {{ expatriateData.workOrder.machine.machineModel }}</span
                  >
                  <span
                    >{{ $lange == "en" ? "Request Type" : "请求类型" }}:
                    {{
                      ["一般咨询", "配件申请", "问题故障"][
                        expatriateData.workOrder.requestType
                      ]
                    }}</span
                  >
                  <template v-if="expatriateData.workOrder.requestType === 3">
                    <span
                      >{{
                        $lange == "en" ? "Fault classification" : "故障分类"
                      }}:
                      {{
                        expatriateData.workOrder.malfunctionAttribute.name
                      }}</span
                    >
                    <span
                      >{{ $lange == "en" ? "Source of problem" : "问题来源" }}:
                      {{ expatriateData.workOrder.problemAttribute.name }}</span
                    >
                  </template>
                  <template v-else>
                    <span></span>
                    <span></span>
                  </template>
                </div>

                <div class="list-title">
                  <div class="title-text">
                    {{ $lange == "en" ? "Remark" : "工程师备注" }}:
                  </div>
                  <div class="remark-lists">
                    <template
                      v-for="remarkItem in expatriateData.workOrder.extraData"
                    >
                      <span
                        >--{{ remarkItem.remark }} --{{
                          `${remarkItem.adminName} ${remarkItem.createTime}`
                        }}</span
                      >
                    </template>
                  </div>
                </div>
                <div class="list-title">
                  <div class="title-text">
                    {{ $lange == "en" ? "Solution Recomended" : "解决方案" }}:
                  </div>
                  <div
                    class="html-context"
                    v-html="
                      expatriateData.workOrder.schemeList[0].workOrderLogList[0]
                        .replyContent
                    "
                  >
                    {{
                      expatriateData.workOrder.schemeList[0].workOrderLogList[0]
                        .replyContent
                    }}
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane
        :label="$lange == 'en' ? 'Task Assignment' : '任务指派'"
        name="task"
      >
        <div class="task">
          <div class="content">
            <div class="task-title">
              <p v-if="taskData != ''">
                {{ $lange == "en" ? "Person in charge" : "负责人" }}:
                {{ taskData[0].adminName }}
              </p>
              <p v-else>
                {{ $lange == "en" ? "Person in charge" : "负责人" }}:
                {{ "---" }}
              </p>
              <p>
                {{ $lange == "en" ? "Team members" : "团队成员" }}:
                {{ userNames || "---" }}
              </p>
            </div>
            <el-row
              style="margin-top: 20px"
              v-if="ganttData.length > 0"
              type="flex"
            >
              <el-col :span="15">
                <div class="table-box not-padding table-bottom">
                  <cc-table
                    :config="ganttTableConfig"
                    :dataArr="ganttData"
                    :loadData="tableFlag"
                    :stripe="false"
                  ></cc-table>
                </div>
              </el-col>
              <el-col :span="9">
                <div class="ganntt-box">
                  <Gantt
                    :utasks="ganttData"
                    :isMerge="true"
                    :childHeight="41"
                    v-if="!showMembers"
                  ></Gantt>
                </div>
              </el-col>
            </el-row>

            <div class="btn-group flex-between" v-if="isEdit">
              <el-button size="small " type="primary" @click="submitAudit">{{
                $lange == "en" ? "Submit audit" : "提交审核"
              }}</el-button>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane
        :label="$lange == 'en' ? 'Service Report' : '服务报告'"
        name="report"
      >
        <div class="report">
          <div class="flex-between">
            <p>{{ $lange == "en" ? "Service report" : "服务报告" }}</p>
            <div>
              <template v-if="expatriateData.infoList.expatriateReport != null">
                <div
                  class="batchFileInfoList_box"
                  v-for="(item, index) in expatriateData.infoList
                    .expatriateReport.batchFileInfoList"
                  :key="index"
                >
                  <span
                    class="download-file"
                    @click="downloadFile(item, item.fileName)"
                    >{{ item.fileName }}</span
                  >

                  <span style="display: inline-block" v-if="isEdit">
                    <el-button
                      type="text"
                      size="mini"
                      style="color: #f56c6c; line-height: 0; margin-left: 10px"
                      @click="deleteBatchFileInfoList(index)"
                      >{{ $lange == "en" ? "Delete" : "删除" }}</el-button
                    >
                  </span>
                </div>
              </template>
              <template v-if="isEdit && showCcUploader">
                <div v-if="isEdit && showCcUploader">
                  <cc-uploader
                    :config="uploaderConf2"
                    :useSuccess="true"
                    @upload-success="reportUploadSuccess"
                  />
                </div>
              </template>
            </div>
          </div>

          <div class="flex-between">
            <p>{{ $lange == "en" ? "Bill pictures" : "票据图片" }}</p>

            <div class="img-lists flex-between">
              <!--                            <template v-if="expatriateData.infoList.expatriate != null">-->
              <div
                v-for="(item, index) in imageArr"
                class="list"
                @click="showBigImageFun(item)"
                :style="`background: url(${item.accessoryUrl}) no-repeat center / cover`"
              >
                <i
                  class="del-icon el-icon-close"
                  v-if="isEdit"
                  @click.stop="delImage(index)"
                ></i>
              </div>
              <!--                            </template>-->
              <div class="list" v-if="isEdit">
                <cc-uploader
                  :config="uploaderConf2"
                  uploadType="dottedLine"
                  @upload-success="invoiceUploadSuccess"
                  :isMultiple="true"
                />
              </div>
            </div>
          </div>
          <div v-if="isEdit">
            <el-button type="primary" size="small" @click="postUploadFile">{{
              $lange == "en" ? "Submit" : "提交"
            }}</el-button>
            <div style="color: #909399; margin-top: 10px">
              <i class="el-icon-warning"></i>
              {{
                $lange == "en"
                  ? "After submitting the service report, the dispatched engineer will not be able to fill in the daily report, please make a notice!"
                  : "提交服务报告后，外派工程师将不能填写日报，请做好通知！"
              }}
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="back-btn" @click="backBtn" v-if="!isDialog">
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-circle-close"
      ></el-button>
    </div>
    <el-dialog
      :title="$lange == 'en' ? 'Details' : '录入服务时间'"
      :visible.sync="setDateFlag"
      width="30%"
      append-to-body
    >
      <el-form ref="form" :model="setDateForm" label-width="120px" size="mini">
        <el-form-item :label="$lange == 'en' ? 'Start time' : '预计开始时间'">
          <el-date-picker
            v-model="setDateForm.startTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'End time' : '预计结束时间'">
          <el-date-picker
            v-model="setDateForm.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <div class="flex-between" style="justify-content: flex-end">
          <el-button type="primary" size="mini" @click="setDateFun">{{
            $lange == "en" ? "Save" : "保存"
          }}</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Appointees' : '指派人员'"
      :visible.sync="showMembers"
      width="80%"
      append-to-body
    >
      <div style="margin-bottom: 15px">
        {{ $lange == "en" ? "Choice scope" : "选择范围" }}:
        <el-date-picker
          v-model="membersSearch.startTime"
          style="width: 150px"
          value-format="yyyy-MM-dd"
          type="date"
          @change="getMembers"
          size="mini"
          placeholder="选择日期"
        ></el-date-picker>
        {{ $lange == "en" ? "To" : "到" }}
        <el-date-picker
          v-model="membersSearch.endTime"
          style="width: 150px"
          value-format="yyyy-MM-dd"
          type="date"
          size="mini"
          @change="getMembers"
          placeholder="选择日期"
        ></el-date-picker>
      </div>

      <div>
        {{ $lange == "en" ? "Assignment date" : "指派日期" }}:
        <el-date-picker
          v-model="ganttDateRange.startTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          @change="showGanttDate"
          size="mini"
          placeholder="选择日期"
        ></el-date-picker>
        {{ $lange == "en" ? "To" : "到" }}
        <el-date-picker
          v-model="ganttDateRange.endTime"
          value-format="yyyy-MM-dd"
          type="date"
          style="width: 150px"
          size="mini"
          @change="showGanttDate"
          placeholder="选择日期"
        ></el-date-picker>
      </div>

      <div class="engineer-box flex-between" v-if="membersData.length > 0">
        <p style="min-width: 130px">
          {{ $lange == "en" ? "Engineer" : "工程师" }}:
          {{ membersData[membersTableConfig.radioValue].userName }}
        </p>
      </div>
      <el-row style="margin-top: 10px">
        <el-col :span="11">
          <div class="table-box not-padding">
            <cc-table
              :config="membersTableConfig"
              :dataArr="membersData"
              :load-data="false"
            ></cc-table>
          </div>
        </el-col>
        <el-col :span="13">
          <Gantt
            :utasks="membersData"
            :isAssign="true"
            :is-start-time="membersSearch.startTime"
            :isAddWeek="true"
            :is-end-time="membersSearch.endTime"
            v-if="membersGantt"
            :childHeight="36"
          ></Gantt>
        </el-col>
      </el-row>
      <div class="btn-box flex-between">
        <el-button
          type="info"
          size="mini"
          style="margin-right: 20px"
          @click="showMembers = false"
          >{{ $lange == "en" ? "Cancel" : "取消" }}</el-button
        >
        <el-button type="primary" size="mini" @click="saveMembers">{{
          $lange == "en" ? "Submit" : "提交"
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Show image' : '查看图片'"
      :visible.sync="showBigImageFlag"
      width="80%"
      append-to-body
    >
      <img :src="showBigImageUrl" style="display: block; margin: 0 auto;width: 100%;" alt />
    </el-dialog>
    <el-dialog
      :title="$lange == 'en' ? 'Engineer' : '工程师'"
      :visible.sync="showEngineer"
      width="450px"
      append-to-body
    >
      <el-form
        size="mini"
        label-width="120px"
        v-loading="dialogLoading"
        v-if="engineerData.sysUserInfo.username"
      >
        <el-form-item label>
          <div
            class="img-box"
            :style="`transform: translateX(-46px);background: url(${
              engineerData.sysUserInfo.avatarurl.length > 0
                ? engineerData.sysUserInfo.avatarurl
                : notImageUrl
            }) no-repeat center / cover`"
          ></div>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Name: ' : '名称: '">
          <span>{{ engineerData.sysUserInfo.username }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Department: ' : '部门: '">
          <span>{{ engineerData.sysUserInfo.deptName }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Category: ' : '类别: '">
          <span>{{ engineerData.sysUserInfo.categoryName }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Resident: ' : '驻地: '">
          <span>{{ engineerData.sysUserInfo.station }}</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Skill: ' : '技能: '">
          <span>{{ engineerData.sysUserInfo.skill }}</span>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Language ability: ' : '语言能力: '"
        >
          <span>{{ engineerData.sysUserInfo.langSkills }}</span>
        </el-form-item>
        <el-form-item
          :label="$lange == 'en' ? 'Target business trip' : '目标出差'"
        >
          <span>{{ engineerData.sysUserInfo.travelDays }}天</span>
        </el-form-item>
        <el-form-item :label="$lange == 'en' ? 'Other: ' : '其他: '">
          <template v-if="$lange == 'en'">
            <el-tag type="success" style="margin-right: 10px"
              >Cumulative travel {{ engineerData.travelDaysTotal }} Day</el-tag
            >
            <el-tag type="success"
              >Accumulated working hours
              {{ engineerData.workHourTotal }}</el-tag
            >
          </template>
          <template v-else>
            <el-tag type="success" style="margin-right: 10px"
              >累计出差{{ engineerData.travelDaysTotal }}天</el-tag
            >
            <el-tag type="success"
              >累计工时{{ engineerData.workHourTotal }}小时</el-tag
            >
          </template>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Gantt from "../../components/Gantt";
import Status from "./components/Status.vue";
import isAudit from "./components/isAudit.vue";
import axios from "axios";
let TaskFunctions = {
  getMembers() {
    this.membersData = [];
    this.membersGantt = false;
    let data = this.membersSearch;
    if (this.projectUserId) {
      data.userId = this.projectUserId;
    }
    delete data.value;

    this.ccRequest
      .do("admin/fsb/project/task/queryTasksIsNull", data, "GET")
      .then((res) => {
        if (res.length > 0) {
          for (let i in res) {
            if (res[i].items && res[i].items.length > 0) {
              res[i].startTime = res[i].items[0].startTime;
              res[i].endTime = res[i].items[0].endTime;
              for (let j in res[i].items) {
                if (res[i].items[j].customerName.length > 0) {
                  res[i].items[
                    j
                  ].value = `${res[i].items[j].customerName} —— ${res[i].items[j].value}`;
                }
              }
            } else {
              res[i].startTime = this.ganttDateRange.startTime;
              res[i].endTime = this.ganttDateRange.startTime;
            }
          }
          let newData = {
            startTime: this.ganttDateRange.startTime,
            endTime: this.ganttDateRange.endTime,
            value: "选中",
            workType: 3,
          };
          res[this.membersTableConfig.radioValue].items.push(newData);
          this.membersData = res;
        }

        this.membersGantt = true;
        // this.dialogLoading = false;
      })
      .catch((res) => {
        console.log(res, "response");
        this.membersGantt = true;
        this.$message({
          type: "error",
          message: "选择的时间不在任务时间范围中",
        });
      });
  },
  getTask() {
    let data = {
      fasId: this.expatriateData.workOrder.product.fasId,
      objId: this.expatriateData.projectId,
      objType: 1,
    };
    this.ccRequest
      .do("admin/fsb/project/task/queryTasks", data, "GET")
      .then((res) => {
        let data = res.tasks.rows;
        let newData = [];
        for (let i in data) {
          data[i].value = data[i].tasksTitle;
          newData.push(data[i]);
          if (data[i].items) {
            for (let j in data[i].items) {
              data[i].items[j].status = -1;
              newData.push(data[i].items[j]);
            }
          }
        }

        this.expatriateData.relStartTime = newData[0].relStartTime;
        this.expatriateData.relEndTime = newData[0].relEndTime;
        this.expatriateData.relWorkHour = newData[0].relWorkHour;

        this.productData = res.product;
        this.projectTasksId = res.project.id;
        this.userNames = res.userNames;
        this.taskData = res.tasks.rows;
        this.ganttData = newData;
      });
  },
  saveMembers() {
    let data = {
      startTime: this.ganttDateRange.startTime,
      endTime: this.ganttDateRange.endTime,
      userId: this.membersData[this.membersTableConfig.radioValue].userId,
      isLeader: this.isLeader ? 1 : 0,
      projectTasksId: this.projectTasksId,
      jobId: this.productData.jobId,
      type: 1,
    };
    this.projectChildTaskId ? (data.id = this.projectChildTaskId) : false;
    this.ccRequest
      .do("admin/fsb/employee/save", data, "POSTJSON")
      .then((res) => {
        this.$message({
          type: "success",
          message: "提交成功",
        });
        this.showMembers = false;
        this.projectChildTaskId = false;
        this.projectUserId = false;
        this.getTask();
      })
      .catch((res) => {
        this.$message({
          type: "error",
          message: res.response.data.message,
        });
      });
  },
  showGanttDate() {
    for (let i in this.membersData) {
      for (let j in this.membersData[i].items) {
        if (this.membersData[i].items[j].value == "选中") {
          let data = {
            ...this.membersData[i].items[j],
            ...this.ganttDateRange,
            workType: 3,
          };
          this.membersData[i].items.splice(j, 1);
          this.membersData[i].items.push(data);
        }
      }
    }
  },
  submitAudit() {
    this.$confirm("确定全部提交审核吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        let idx = [];
        for (let i in this.ganttData) {
          if (this.ganttData[i].isLeader === undefined) {
            idx.push(this.ganttData[i].id);
          }
        }

        let data = {
          ids: idx.join(","),
          fasId: this.expatriateData.workOrder.product.fasId,
          workOrderId: this.expatriateData.workOrder.id,
        };
        this.ccRequest
          .do("admin/fsb/employee/submitAudit", data, "GET")
          .then((res) => {
            this.$message({
              type: "success",
              message: "已提交",
            });
            this.getData();
          });
      })
      .catch(() => {});
  },
};
let TaskData = {
  taskData: [],
  tableFlag: false,
  ganttFlag: true,
  showMembers: false,
  membersGantt: false,
  projectUserId: false,
  projectTasksId: false,
  isLeader: false,
  ganttDateRange: {
    startTime: "",
    endTime: "",
  },
  membersSearch: {
    startTime: moment(new Date()).format("YYYY-MM-DD"),
    endTime: moment(new Date()).format("YYYY-MM-DD"),
  },
  projectChildTaskId: false,

  ganttData: [],
  membersData: [],
  userNames: "",
  productData: {},
};
let notImageUrl = require("../../assets/not-image.png");
export default {
  name: "ExpartiateDescription",
  components: {
    Gantt,
  },
  props: {
    id: String,
    isEditV2: Boolean,
    isDialog: Boolean,
  },
  watch: {
    "membersTableConfig.radioValue": {
      handler(newData, lastData) {
        if (
          this.membersData[lastData].items &&
          this.membersData[lastData].items.length > 0
        ) {
          for (let i in this.membersData[lastData].items) {
            if (this.membersData[lastData].items[i].value == "选中") {
              this.membersData[lastData].items.splice(i, 1);
            }
          }
        }
        let data = this.ganttDateRange;
        data.value = "选中";
        data.workType = 3;
        this.membersData[newData].items.push(data);
      },
    },
  },
  data() {
    return {
      tabText: [],
      notImageUrl: notImageUrl,
      showEngineer: false, //任务指派的时候, 点击查看工程师的数据
      dialogLoading: false, //任务指派的时候, 点击查看工程师的数据
      //任务指派的时候, 点击查看工程师的数据
      engineerData: {
        sysUserInfo: {},
        travelDaysTotal: 2,
        workHourTotal: 0,
      },
      showData: false,
      uploaderConf2: this.$uploadUtils.config,
      activeName: "description",
      collapseContent: true,
      desId: "",
      isEdit: false,
      desTableConfig: {
        columns: [
          {
            prop: "workOrder.jobId",
            lable: "Job ID",
          },
          {
            prop: "workOrder.product.fasId",
            lable: "FAS",
          },
          {
            prop: "workOrder.product.productLine",
            lable: this.$lange == "en" ? "Product Line" : "产品线",
          },
          {
            prop: "workOrder.product.warrantyEndTime",
            lable:
              this.$lange == "en" ? "Warranty Expiration Date" : "保修截止日期",
            type: "date",
            render: (row) => {
              return moment(row.workOrder.product.warrantyEndTime).format(
                "YYYY-MM-DD"
              );
            },
          },
          {
            prop: "peopleNum",
            lable: this.$lange == "en" ? "Estimated Engineers" : "预计人数",
            type: "input",
          },
          {
            prop: "workHour",
            lable:
              this.$lange == "en"
                ? "Estimated Working Hours"
                : "预计工时 (小时)",
            type: "input",
          },
          {
            lable: this.$lange == "en" ? "Service Start Time" : "预计开始时间",
            render: (row) => {
              let res = "待预约";
              if (
                row.workOrder.schemeList[0].workOrderLogList[0].expatriateOrder
                  .startTime
              ) {
                res = moment(
                  row.workOrder.schemeList[0].workOrderLogList[0]
                    .expatriateOrder.startTime
                ).format("YYYY-MM-DD");
              }
              return res;
            },
          },
          {
            lable:
              this.$lange == "en" ? "Estimated Service Time" : "预计结束时间",
            render: (row) => {
              let res = "待预约";
              if (
                row.workOrder.schemeList[0].workOrderLogList[0].expatriateOrder
                  .endTime
              ) {
                res = moment(
                  row.workOrder.schemeList[0].workOrderLogList[0]
                    .expatriateOrder.endTime
                ).format("YYYY-MM-DD");
              }
              return res;
            },
          },
          {
            lable:
              this.$lange == "en" ? "Estimated Service Time" : "实际开始时间",
            render: (row) => {
              let res = "---";
              if (row.relStartTime) {
                res = moment(row.relStartTime).format("YYYY-MM-DD");
              }
              return res;
            },
          },
          {
            lable:
              this.$lange == "en" ? "Estimated Service Time" : "实际结束时间",
            render: (row) => {
              let res = "---";
              if (row.relEndTime) {
                res = moment(row.relEndTime).format("YYYY-MM-DD");
              }
              return res;
            },
          },
          {
            lable:
              this.$lange == "en" ? "Estimated Service Time" : "实际总工时",
            // render: row => {
            //   let res = "---";
            //   if (row.relWorkHour) {
            //     res = moment(row.relWorkHour).format("YYYY-MM-DD");
            //   }
            //   return res;
            // }
          },
        ],
      },
      setDateFlag: false,
      setDateForm: {
        startTime: "",
        endTime: "",
      },
      expatriateData: {
        workOrder: {
          title: "",
          description: "",
        },
      },
      //服务报告
      showBigImageUrl: "",
      showBigImageFlag: false,

      //任务指派
      ganttTableConfig: {
        rowClassName: ({ row, rowIndex }) => {
          if (row.isLeader === undefined) {
            return "info-row";
          } else {
            return "";
          }
        },
        height: "150px",
        showIndex: false,
        columns: [
          {
            prop: "tasksTitle",
            lable: this.$lange == "en" ? "Task name" : "任务名称",
            type: "input",
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Team members" : "团队成员",
            minWidth: "200",
            type: "input",
            render: function (row) {
              let res = `${row.userName}`;
              if (row.isLeader === 1) {
                res = `(组) ${row.userName}`;
              }

              return row.userName && row.userName.length > 0 ? res : "---";
            },
          },
          {
            prop: "startTime",
            lable: this.$lange == "en" ? "Expected start" : "预计开始",
            type: "datetime",
            minWidth: "90px",
            render: (row) => {
              return moment(row.startTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "endTime",
            lable: this.$lange == "en" ? "Expected End" : "预计结束",
            type: "datetime",
            minWidth: "90px",
            render: (row) => {
              return moment(row.endTime).format("YYYY-MM-DD");
            },
          },
          {
            prop: "workHour",
            lable: this.$lange == "en" ? "Total time" : "预计总工时",
            type: "input",
            minWidth: "100px",
          },
          {
            prop: "relStartTime",
            lable: this.$lange == "en" ? "Actual start" : "实际开始",
            type: "date",
            minWidth: "90px",
            render: (row) => {
              return row.relStartTime
                ? moment(row.relStartTime).format("YYYY-MM-DD")
                : "---";
            },
          },
          {
            prop: "relEndTime",
            lable: this.$lange == "en" ? "Actual end" : "实际结束",
            type: "date",
            minWidth: "90px",
            render: (row) => {
              return row.relEndTime
                ? moment(row.relEndTime).format("YYYY-MM-DD")
                : "---";
            },
          },
          {
            prop: "relWorkHour",
            lable: this.$lange == "en" ? "Actual total hour" : "实际总工时",
            type: "input",
            minWidth: "90px",
          },
          {
            prop: "status",
            lable: this.$lange == "en" ? "Task status" : "任务状态",
            type: "component",
            componentName: Status,
            // type: "tag",
            // options: [
            //   {
            //     tagType: "info",
            //     text: this.$lange == "en" ? "Not yet begun" : "未开始",
            //   },
            //   {
            //     tagType: "warning",
            //     text: this.$lange == "en" ? "Have in hand" : "进行中",
            //   },
            //   {
            //     tagType: "success",
            //     text: this.$lange == "en" ? "Completed" : "已完成",
            //   },
            //   {
            //     tagType: "danger",
            //     text: this.$lange == "en" ? "Delay" : "延迟",
            //   },
            // ],
          },
          {
            prop: "remark",
            lable: this.$lange == "en" ? "Task remark" : "任务备注",
            minWidth: "120",
            render: (row) => {
              let res = "---";
              if (row.remark && row.remark.length > 0) {
                res = row.remark;
              }
              return res;
            },
          },
          {
            prop: "isAudit",
            lable: this.$lange == "en" ? "Approval status" : "审批状态",
            type: "component",
            componentName: isAudit,
            // type: "tag",
            // options: [
            //   {
            //     tagType: "warning",
            //     text: this.$lange == "en" ? "To be audited" : "待审核",
            //   },
            //   {
            //     tagType: "success",
            //     text: this.$lange == "en" ? "Audit pass" : "审核通过",
            //   },
            //   {
            //     tagType: "danger",
            //     text: this.$lange == "en" ? "Audit failed" : "审核未通过",
            //   },
            //   {
            //     tagType: "info",
            //     text: this.$lange == "en" ? "Not submitted" : "未提交",
            //   },
            // ],
          },
          {
            prop: "reviewMessage",
            lable: this.$lange == "en" ? "Approval remark" : "审批备注",
            minWidth: "120",
            render: (row) => {
              let res = "---";
              if (row.reviewMessage && row.reviewMessage.length > 0) {
                res = row.reviewMessage;
              }
              return res;
            },
          },
        ],
        buttonsLabel: this.$lange == "en" ? "Operation" : "操作",
        buttons: [
          {
            name: this.$lange == "en" ? "Edit" : "编辑",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (row.isLeader !== undefined && this.isEdit === true) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              // console.log(row, "1111")
              this.projectUserId = row.userId;
              this.projectChildTaskId = row.id;
              this.projectTasksId = row.projectTasksId
                ? row.projectTasksId
                : row.id;
              this.membersSearch.userId = row.userId;
              this.getMembers();
              this.membersSearch.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.membersSearch.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.showMembers = true;
            },
          },
          {
            name: this.$lange == "en" ? "Delete" : "删除",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (row.isLeader !== undefined && this.isEdit === true) {
                res = true;
              }
              return res;
            },
            click: (row, $index) => {
              this.$confirm("此操作会删除该指派?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              })
                .then(() => {
                  let data = {
                    id: row.id,
                  };
                  this.ccRequest
                    .do("admin/fsb/employee/delete", data, "GET")
                    .then((res) => {
                      this.$message({
                        type: "success",
                        message: "该指派已删除",
                      });
                      this.getTask();
                    });
                })
                .catch(() => {
                  // this.$message({
                  //     type: 'info',
                  //     message: '已取消删除'
                  // });
                });
            },
          },
          {
            name: this.$lange == "en" ? "Assign" : "指派",
            check: (row) => {
              console.log(this.isEdit);
              let res = false;
              if (row.isLeader === undefined && this.isEdit === true) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              console.log(row.id, "111");
              this.projectTasksId = row.id;
              this.getMembers();
              this.membersSearch.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.membersSearch.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.startTime = moment(row.startTime).format(
                "YYYY-MM-DD"
              );
              this.ganttDateRange.endTime = moment(row.endTime).format(
                "YYYY-MM-DD"
              );
              this.showMembers = true;
              // this.ccRequest.do("admin/fsb/employee/getLeader", {projectTasksId: row.id}, "GET").then(res => {
              //     this.showMembers = true;
              //     this.isLeader = !res;
              // })
            },
          },

          {
            name: this.$lange == "en" ? "Set team leader" : "设置为队长",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (
                row.isLeader !== undefined &&
                row.isLeader !== 1 &&
                this.isEdit === true
              ) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              // 设置队长：/admin/fsb/employee/updateCaptain 参数：id（员工任务的id） projectTasksId（项目任务的id） isLeader（0-非组长，1-组长）
              this.ccRequest
                .do(
                  "admin/fsb/employee/updateCaptain",
                  {
                    id: row.id,
                    projectTasksId: row.projectTasksId,
                    isLeader: 1,
                  },
                  "GET"
                )
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "设置成功",
                  });
                  this.getTask();
                })
                .catch((res) => {
                  this.$message({
                    type: "warning",
                    message: "一个任务只能存在一个队长",
                  });
                });
            },
          },
          {
            name: this.$lange == "en" ? "Cancel team leader" : "取消队长",
            btnColor: "btn-gary-color",
            check: (row) => {
              let res = false;
              if (row.isLeader === 1 && this.isEdit === true) {
                res = true;
              }
              return res;
            },
            click: (row) => {
              this.ccRequest
                .do(
                  "admin/fsb/employee/updateCaptain",
                  {
                    id: row.id,
                    projectTasksId: row.projectTasksId,
                    isLeader: 0,
                  },
                  "GET"
                )
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "设置成功",
                  });
                  this.getTask();
                });
            },
          },
        ],
      },
      membersTableConfig: {
        radioValue: 0,
        showIndex: false,
        height: "150px",
        columns: [
          {
            prop: "radioValue",
            lable: this.$lange == "en" ? "Choose" : "选择",
            type: "radio",
            minWidth: "20px",
          },
          {
            prop: "userName",
            lable: this.$lange == "en" ? "Engineer" : "工程师",
            clickFun: (row) => {
              let pData = {
                userId: row.userId,
              };
              this.showEngineer = true;
              this.dialogLoading = true;
              this.ccRequest
                .do("admin/fsb/employeeinfo/getEmployeeInfo", pData, "GET")
                .then((res) => {
                  this.engineerData = res;
                  this.dialogLoading = false;
                })
                .catch((res) => {
                  this.dialogLoading = false;
                });
            },
          },
          {
            prop: "station",
            lable: this.$lange == "en" ? "Current location" : "目前所在位置",
            render: (row) => {
              let res = row.station;
              let data = row.items;
              let today = moment(new Date()).format("YYYY-MM-DD");
              if (row.items) {
                for (let i in data) {
                  // console.log(data[i].startTime < today , data[i].endTime > today)
                  if (
                    data[i].startTime < today &&
                    data[i].endTime > today &&
                    data[i].workType !== 3
                  ) {
                    if (data[i].product) {
                      res = data[i].product.productAddress;
                    }
                  }
                }
              }

              // res = row.
              return res;
            },
          },
          {
            prop: "skill",
            lable: this.$lange == "en" ? "Skill" : "技能",
            type: "input",
          },
        ],
      },
      ...TaskData,
      imageArr: [],
      showCcUploader: true,
    };
  },
  methods: {
    getTabText() {
      this.ccRequest
        .do("admin/dict/pageTree", { code: "priority" }, "GET")
        .then((res) => {
          let tabText = {};
          if (res.rows && res.rows.length > 0) {
            for (let index = 0; index < res.rows[0].children.length; index++) {
              if (this.$lange == "zh") {
                tabText[res.rows[0].children[index].title] =
                  res.rows[0].children[index].title;
              } else {
                if (
                  res.rows[0].children[index].extraData &&
                  res.rows[0].children[index].extraData[this.$lange]
                ) {
                  tabText[res.rows[0].children[index].title] =
                    res.rows[0].children[index].extraData[this.$lange];
                } else {
                  tabText[res.rows[0].children[index].title] =
                    res.rows[0].children[index].title;
                }
              }
            }
            this.tabText = tabText;
          }
        });
    },
    gotoPage(path, key, value) {
      let query = {};
      query[key] = value;
      this.$router.push({
        path: path,
        query: query,
      });
    },
    downloadFile(data, name) {
      console.log(data, name);
      if (data.fileName.indexOf("pdf") > -1) {
        let pData = {
          url: data.accessoryUrl,
        };
        // return this.ccRequest
        //   .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
        //   .then(res => {
        //     axios({
        //       method: "get",
        //       url: res.url,
        //       headers: {
        //         "Content-Disposition": "attachment"
        //       }
        //     }).then(res2 => {
        //       this.$message({
        //         type: "success",
        //         message: "文件开始下载"
        //       });
        //     });
        //   });
        this.ccRequest
          .do("admin/fsb/file/aliyun/privateDownloadUrl", pData, "GET")
          .then((res) => {
            let a = document.createElement("a");
            a.href = res.url;
            a.download = name;
            a.click();
            this.$message({
              type: "success",
              message: "文件开始下载",
            });
          });
      } else {
        this.$message({
          type: "success",
          message: "文件开始下载",
        });
        let imageType = ["png", "jpg", "jpeg", "webp"];
        for (let i in imageType) {
          if (data.fileName.indexOf(imageType[i]) > -1) {
            this.downloadImage(data.accessoryUrl, name);
            return false;
          }
        }
        // let a = document.createElement("a");
        // a.href = data.accessoryUrl;
        // a.download = name;
        // a.click();
      }
    },
    downloadImage(imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    //任务指派
    ...TaskFunctions,
    //上传验收报告之前 检查是否未完成项目

    //服务报告
    backBtn() {
      this.$router.go(-1);
    },
    delImage(index) {
      this.imageArr.splice(index, 1);
      // this.expatriateData.infoList.expatriate.batchFileInfoList.splice(index,1);
    },
    showBigImageFun(item) {
      this.showBigImageUrl = item.accessoryUrl;
      this.showBigImageFlag = true;
    },
    reportUploadSuccess(res) {
      if (this.expatriateData.infoList.expatriateReport) {
        let batchFileInfoList =
          this.expatriateData.infoList.expatriateReport.batchFileInfoList;
        //从第二个开始
        this.expatriateData.infoList.expatriateReport.batchFileInfoList.push({
          fileName: res.fileName,
          accessoryUrl: res.accessoryUrl,
        });
      } else {
        //第一个
        this.expatriateData.infoList.expatriateReport = {
          batchFileInfoList: [
            { fileName: res.fileName, accessoryUrl: res.accessoryUrl },
          ],
          objType: "expatriateReport",
          objId: this.expatriateData.id,
        };
      }
      // this.expatriateData.infoList.expatriateReport.batchFileInfoList[0].fileName = res.fileName;
      // this.expatriateData.infoList.expatriateReport.batchFileInfoList[0].accessoryUrl = res.accessoryUrl;
      this.$message({
        type: "success",
        message: "上传成功",
      });
      this.showCcUploader = false;
      setTimeout(() => {
        this.showCcUploader = true;
      }, 0);
    },
    invoiceUploadSuccess(res) {
      this.imageArr.push({
        accessoryUrl: res,
      });

      // this.expatriateData.infoList.expatriate.batchFileInfoList.push({
      //     accessoryUrl: res
      // })
    },
    postUploadFile() {
      // for (let i in this.ganttData) {
      //   if (this.ganttData[i].status !== -1 && this.ganttData[i].status !== 2) {
      //     return this.$message({
      //       type: "danger",
      //       message: "工程师外派任务还未完成, 不能提交验收报告"
      //     });
      //   }
      // }
      this.expatriateData.infoList.expatriate.batchFileInfoList = this.imageArr;
      // expatriateData.infoList.expatriateReport.batchFileInfoList[0].fileName
      if (
        !this.expatriateData.infoList.expatriateReport &&
        !this.expatriateData.infoList.expatriate
      ) {
        return this.$message({
          type: "danger",
          message: "请上传相关的文件或者图片",
        });
      }
      let text = "该操作会提交服务报告";
      if (this.expatriateData.projectId === 0) {
        text = "该外派单还未完成";
      }
      this.$confirm(`${text}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // expatriateOrderId: this.expatriateData.id,
        //     infoList: this.expatriateData.infoList,
        let postData = {
          ...this.expatriateData.infoList,
        };
        console.log(postData, "psots");
        // return false;
        this.ccRequest
          .do("admin/fsb/expatriate/saveAccessoryInfos", postData, "POSTJSON")
          .then((res) => {
            this.$message({
              type: "success",
              message: "提交成功",
            });
            this.backBtn();
          });
      });
    },

    getExpariate() {
      let data = {
        id: this.desId,
        // id: 1
      };
      this.ccRequest
        .do("admin/fsb/expatriate/get", data, "GET")
        .then((res) => {
          // console.log(res, "res")
          if (res.infoList.expatriate === null) {
            res.infoList.expatriate = {
              batchFileInfoList: [],
              objType: "expatriate",
              objId: res.id,
            };
          }
          this.imageArr = res.infoList.expatriate.batchFileInfoList;
          this.expatriateData = res;
          this.showData = true;
          this.getTask();
        })
        .catch((res) => {
          this.showData = true;
        });
    },
    getData() {
      this.getExpariate();
    },
    setDateFun() {
      let data = {
        expatriateOrderId: this.expatriateData.id,
        workOrderId: this.expatriateData.workOrder.id,
        ...this.setDateForm,
      };

      if (!data.startTime || !data.endTime) {
        return this.$message({
          type: "warning",
          message: "请选择时间",
        });
      }
      this.ccRequest
        .do("admin/fsb/expatriate/addTasks", data, "POSTJSON")
        .then((res) => {
          this.expatriateData.workOrder.schemeList[0].workOrderLogList[0].expatriateOrder.endTime =
            data.endTime;
          this.expatriateData.workOrder.schemeList[0].workOrderLogList[0].expatriateOrder.startTime =
            data.startTime;
          this.setDateFlag = false;
          this.getExpariate();
          this.$message({
            type: "success",
            message: "录入成功",
          });
        });
    },

    //删除 服务报告
    deleteBatchFileInfoList(index) {
      if (
        this.expatriateData.infoList.expatriateReport.batchFileInfoList
          .length == 1
      ) {
        this.expatriateData.infoList.expatriateReport = null;
      } else {
        this.expatriateData.infoList.expatriateReport.batchFileInfoList.splice(
          index,
          1
        );
      }
    },
  },
  mounted() {
    if (!this.isDialog) {
      if (this.$route.query.id) {
        this.desId = this.$route.query.id;
      }
      if (this.$route.query.isEdit) {
        this.isEdit = true;
      }
    } else {
      this.desId = this.id;
      this.isEdit = this.isEditV2;
    }

    this.getData();
    this.getTabText();
  },
};
</script>
<style lang="scss">
.html-context {
  display: inline-block;
  img {
    max-width: 400px !important;
  }
}
.report .dottedUpload {
  min-width: 80px;
}
</style>
<style scoped lang="scss">
.download-file {
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #1ab394;
  }
}
.exp-des {
  background: #ffffff;
  .table-box {
    margin-top: 20px;
  }

  .top {
    padding: 15px;
    .msg-lists {
      .msg-list {
        max-width: 85%;
        margin-bottom: 10px;

        & > * {
          white-space: nowrap;
          flex: 0 20%;
          &.jump-url {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
    .btn {
      text-align: center;
      margin: 15px 0 20px 0;
    }
  }

  .bottom {
    border-top: 5px solid #f3f3f4;
    .title {
      padding: 15px;
      font-size: 16px;
      border-bottom: 1px solid #e4e4e4;
    }
    .content {
      padding: 15px;

      .list-title {
        display: flex;
        justify-content: flex-start;
        max-width: 80%;
        margin-bottom: 15px;
        color: #aaa;
        .image-lists {
          display: flex;
          flex-wrap: wrap;
          .image-list {
            width: 80px;
            height: 80px;
            background: skyblue;
            margin-right: 10px;
            border: 1px dotted #e4e4e4;
            cursor: pointer;
          }
        }
        &.msg {
          justify-content: space-between;
        }
        .remark-lists {
          display: flex;
          flex-direction: column;
          > * {
            margin-bottom: 6px;
          }
        }
        .title-text {
          color: #282828;
          margin-right: 5px;
        }
      }
    }
  }
}
.task {
  background: #ffffff;
  padding: 20px;
  .content {
    margin-top: 35px;
    .task-title {
      display: flex;
      > * {
        margin-right: 20px;
      }
      > div {
        margin-left: 25px;
      }
    }
    .table-box {
    }
  }
}
.report {
  background: #ffffff;
  padding: 20px;
  > div {
    align-items: flex-start;
    justify-content: flex-start;
    > p {
      margin-right: 10px;
    }
    &:not(:first-child) {
      margin-top: 20px;
    }
    .img-lists {
      justify-content: flex-start;
      flex-wrap: wrap;
      max-width: 500px;
      .list {
        width: 80px;
        height: 80px;
        position: relative;
        cursor: pointer;
        margin-bottom: 15px;
        > .del-icon {
          z-index: 99;
          position: absolute;
          right: 0;
          top: 0;
          color: #ff0000;
          font-size: 14px;
          width: 14px;
          height: 14px;
          padding: 2px;
          border-radius: 50%;
          border: 1px solid #ff0000;
          text-align: center;
          line-height: 14px;
          transform: translateY(-50%) translateX(50%);
        }
        &:not(:last-child) {
          margin-right: 15px;
          border: 1px dotted #e4e4e4;
        }
      }
    }
  }
}
.btn-box {
  margin-top: 20px;
  justify-content: center;
}
.btn-group {
  border-bottom: 1px solid #e4e4e4;
  padding: 20px;
  &.flex-between {
    justify-content: center;
  }
}
.engineer-box {
  justify-content: flex-start;
  margin-top: 10px;
}
</style>
<style lang="scss">
.expartiate-description {
  .el-tabs__content {
    padding: 0 !important;
  }
}
.batchFileInfoList_box {
  margin-bottom: 10px;
}
</style>
